<!--
 * @Author: shuchang
 * @Date: 2021-07-07 09:10:25
 * @LastEditors: shuchang
 * @LastEditTime: 2022-03-23 15:54:14
 * @Description: 
-->
<template>
    <!--svg图片-->
    <!--在icons/index.js引入icon以及全局注册svg组件-->
    <svg :class="svgClass" aria-hidden="true">
        <use :xlink:href="iconName"/>
    </svg>
</template>

<script>
    export default {
        name: 'SvgIcon',
        props: {
            iconClass: {
                type: String,
                required: true
            },
            className: {
                type: String,
                default: ''
            }
        },
        computed: {
            iconName() {
                return `#icon-${this.iconClass}`
            },
            svgClass() {
                if (this.className) {
                    return 'svg-icon ' + this.className
                } else {
                    return 'svg-icon'
                }
            }
        }
    }
</script>

<style scoped>
    .svg-icon {
        width: 20px;
        height: 20px;
        margin-right: 0px;
        fill: currentColor;
    }
</style>
